<template>
  <div class="sorgente_luminosa_select">
    <v-select
      v-model="LED"
      class="select-group-vue"
      :items="LEDS"
      :class="nascondi_select"
      item-value="SORGENTE"
      item-text="test_led"
      v-on:change="modifica_liste_al_click_di_sorgente_luminosa()"
    >
      <template v-slot:item="{ item }">
        <SorgenteNew :productCode="item.id_prodotto" />
      </template>

      <template v-slot:selection="{ item }">
        <!-- Pass the product code to SorgenteNew -->
        <SorgenteNew :productCode="item.id_prodotto" />
      </template>
    </v-select>
    <div class="faoj3e2ij" :class="mostra_text" v-if="if_mo">
      <SorgenteNew
        :productCode="this.$store.state.product_store.CODICE_UNIVOCO"
      />
    </div>
  </div>
</template>
<script>
/* 11 12 2022
// spiegazioen del codice al mount ascolto degli eventi in particolare l'evento click vetro click modello e click montatura a quel punto devo controllare se ho una sola tipologia di sorgente luminosa se e cosi allora non mostro una selected ma una semplice indformazione 
*/
import sorgenti from "../classes/class_sorgenti";
import checkLanguage from "../classes/class_check_language";
import SorgenteNew from "./../components/sorgenteNew.vue";

export default {
  name: "ledselect",
  components: {
    SorgenteNew,
  },
  data() {
    return {
      change_led_first_time: true,
      SORGENTE: "",
      LED: [],
      LEDS: [],
      count: 0,
      nascondi_select: "",
      mostra_text: "",
      if_mo: false,
      sorgente_modificata: false,
      sorgente_univoca: "",
      is_italian: false,
    };
  },

  mounted() {
    let c = new checkLanguage();
    this.is_italian = c.is_italian();

    // sottoscrivo tutte le mutation
    // avvio
    // click del modello
    // click sul vetro
    // click su montatura
    this.$store.subscribe((mutation) => {
      if (mutation.type == "click_on_vetro") {
        console.info("mutation aaa a");
        this.$store.commit("aggiorna_sorgente_luminosa");
        /*       try {
                     this.LED = this.$store.state.products_store.SORGENTE_LUMINOSA.LED;
            this.LEDS = this.$store.state.products_store.SORGENTE_LUMINOSA.LEDS;
            console.info('mutation aaa click_on_vetro', 'led:',this.LED, 'leds:',this.LEDS)
                    this.change_count(this.LEDS);
            } catch (error) {
              console.info('errore in 45')
            }
     */
      }
      if (mutation.type == "click_on_modello") {
        console.info("mutation aaa b");
        // qui eseguo i filtri per raggruppare i prodotti
        this.$store.commit("aggiorna_sorgente_luminosa");
        //  console.info('k2');
        /*     try {
                     this.LED = this.$store.state.products_store.SORGENTE_LUMINOSA.LED;
            this.LEDS = this.$store.state.products_store.SORGENTE_LUMINOSA.LEDS;
                    this.change_count(this.LEDS);
                       console.info('mutation aaa click_on_modello', 'led:',this.LED, 'leds:',this.LEDS)
         
            } catch (error) {
              console.info('errore in 60')
            }

      */
      }
      if (mutation.type == "selected_paese") {
        console.info("k3");
        console.info("mutation aaa c");
        let s = new sorgenti();
        let PRODS = this.$store.state.products_store.PRODOTTI_VENDIBILI;
        let mv = this.$store.state.product_store.MODELLO_VAR;
        let m = this.$store.state.product_store.VETRO;
        let fs = this.$store.state.product_store.MONTATURA;
        let ps = this.$store.state.paese;
        if (ps == "EU") {
          ps = "CE";
        }
        this.LEDS = s.ottieni_sorgenti_paese(mv, m, fs, ps, PRODS);
        this.LED = this.LEDS[0];
        //this.change_count(this.LEDS);
        this.trova_lelenco_univoco_dei_led(PRODS);
      }
      if (mutation.type == "select_product_by_id") {
        console.info("mutation aaa d");
        //    console.info('k4');
        let s = new sorgenti();
        let cu = this.$store.state.product_store.CODICE_UNIVOCO;
        let PRODS = this.$store.state.products_store.PRODOTTI_VENDIBILI;

        let mv = this.$store.state.product_store.MODELLO_VAR;
        let m = this.$store.state.product_store.VETRO;
        let fs = this.$store.state.product_store.MONTATURA;
        this.LEDS = s.ottieni_sorgenti(mv, m, fs, PRODS);
        if (this.LEDS[0].famiglia == "RIFLE") {
          let modello = this.$store.state.product_store.MODELLO;
          console.info(
            "mv",
            mv,
            "m",
            m,
            "fs",
            fs,
            "leds",
            this.LEDS,
            "modelli",
            this.$store.state.product_store
          );
          this.LEDS = this.LEDS.filter((prodotto) => {
            return prodotto.MODELLO == modello;
          });
        }

        this.LED = s.ottieni_sorgente_value_cod(cu, this.LEDS);
        console.info(
          "mutation select_product_by_id",
          "leds",
          this.LEDS,
          "led",
          this.LED
        );
        //  this.change_count(this.LEDS);
        this.trova_lelenco_univoco_dei_led(PRODS);
        try {
          let sorgenti_luminose =
            this.$store.state.products_store.SORGENTE_PRODUCTS;
          console.info("sorgenti luminose", sorgenti_luminose);
          this.mostra_test_led_sorgente_selected(sorgenti_luminose);
        } catch (error) {
          console.info("error", error);
        }

        /*         try {
                     this.LED = this.$store.state.products_store.SORGENTE_LUMINOSA.LED;
            this.LEDS = this.$store.state.products_store.SORGENTE_LUMINOSA.LEDS;
                    this.change_count(this.LEDS);
                       console.info('mutation aaa click_on_modello', 'led:',this.LED, 'leds:',this.LEDS)
         
            } catch (error) {
              console.info('errore in 60')
            } */
      }

      if (mutation.type == "aggiorna_sorgente_luminosa") {
        // qui eseguo i filtri per raggruppare i prodotti
        //   console.info('k5');
        console.info("mutation aaa e");
        this.LEDS = this.$store.state.products_store.SORGENTE_PRODUCTS;
        //  this.change_count(this.LEDS);
        // qui devo controllare  che i prodotti abbiano la giusta sorgente luminosa
        // io ho una sorgente selezionata va bene o no ?

        this.LED = this.$store.state.products_store.SORGENTE_PRODUCTS[0];

        console.info(
          "sorgente luminosa ",
          this.LED,
          this.$store.state.products_store.SORGENTE_PRODUCTS
        );

        if (
          this.$store.state.products_store.SORGENTE_PRODUCTS[0].FAMIG_ESTESA ==
          "MINIGIOGALI"
        ) {
          let d = this.LEDS.filter((sorgente) => {
            return sorgente.SORGENTE == "E27";
          });
          this.LED = d[0];
        }
        // console.info('agggiorna this.LED', this.LED);
        this.$store.commit("aggiornare_sorgente", this.LED.SORGENTE);
        try {
          let sorgenti_luminose =
            this.$store.state.products_store.SORGENTE_PRODUCTS;
          console.info("sorgenti luminose", sorgenti_luminose);
          this.mostra_test_led_sorgente_selected(sorgenti_luminose);
        } catch (error) {
          console.info("error", error);
        }
      }

      if (mutation.type == "click_on_montatura") {
        //      console.info('k6');
        console.info("mutation aaa f");
        // qui eseguo i filtri per raggruppare i prodotti
        this.$store.commit("aggiorna_sorgente_luminosa");
      }
    });
  },

  methods: {
    mostra_test_led_sorgente_selected(SORGENTI) {
      try {
        let prodotto = SORGENTI.filter((detail) => {
          return detail.SELECTED == true;
        });
        let alternativa = "Alternative light source: ";
        if (this.is_italian) {
          alternativa = "Sorgente alternativa: ";
        }
        console.info("prodotto: ", prodotto);
        console.info(" sorgenti:", SORGENTI);
        if (prodotto.length > 0) {
          if (prodotto[0].el_alt) {
            let f = new sorgenti();

            this.sorgente_univoca = f.crea_html_select(
              prodotto[0].el_main,
              prodotto[0].el_alt,
              alternativa
            );
          } else {
            this.sorgente_univoca = prodotto[0].el_main;
          }
        } else {
          this.sorgente_univoca = SORGENTI[0].el_main;
        }
      } catch (error) {
        console.info(error);
      }
    },
    trova_lelenco_univoco_dei_led(PRODOTTI_VENDIBILI) {
      let LED_ESISTENTI = PRODOTTI_VENDIBILI.filter((product, index, self) => {
        return index === self.findIndex((p) => p.SORGENTE === product.SORGENTE);
      });
      console.table("PRODOTTI VENDIBILI", PRODOTTI_VENDIBILI);
      console.table(LED_ESISTENTI);
      if (LED_ESISTENTI.length == 1) {
        this.nascondi_select = "nascondi_select";
        this.mostra_text = "";
        this.if_mo = true;
        console.info("elemento unico");
      } else {
        this.nascondi_select = "";
        this.mostra_text = "nascondi_text";
        this.if_mo = false;

        console.info("piu elementi");
      }
    },
    modifica_liste_al_click_di_sorgente_luminosa() {
      this.sorgente_modificata = true;

      let s = new sorgenti();
      let a = s.ottieni_sorgente_value(this.LED, this.LEDS);
      this.$store.commit("change_id_prodotto", {
        id_prodtto: a[0].id_prodotto,
        sorgente: this.LED,
      });
    },
    change_count(LEDS) {
      try {
        this.count = LEDS.length;
        if (this.count == 1) {
          this.nascondi_select = "nascondi_select";
          this.mostra_text = "";
          this.if_mo = true;
        } else {
          this.nascondi_select = "";
          this.mostra_text = "nascondi_text";
          this.if_mo = false;
        }
      } catch (error) {
        console.info(error);
        this.count = 0;
      }
    },
  },
};
</script>
<style>
.v-select__selections {
  width: 500px !important;
}
.nascondi_select,
.nascondi_text {
  display: none !important;
}
.led-count-one-only {
  margin-top: 8px !important;
  margin-bottom: 24px !important;
}
.el_main_vix {
  margin-bottom: 3px !important;
  font-size: 15px !important;
  font-weight: 400 !important;
  line-height: 23px !important;
}

.el_alternative_vix {
  margin-bottom: 3px !important;
  font-size: 12px !important;
  font-weight: 300 !important;
  line-height: 18px !important;
}
.sorgente_luminosa_select .v-icon.mdi-menu-down {
  transform: scale(0.8) !important;
  background-repeat: no-repeat !important;
  width: 28px !important;
  background-size: contain !important;
  background: url(/wp-content/uploads/2023/02/down-arrow-svgrepo-com.svg) !important;
  background-position-x: 0%;
  background-position-y: 0%;
  background-size: auto;
  opacity: 1 !important;
  background-position: center !important;
  background-size: cover !important;

  height: 25px !important;
  margin-top: 9px !important;
}
</style>
